import { Grid, _ } from 'gridjs-react';
import { GridJSColumns } from 'lib/types';
import spritemap from '@milestone-sys/web-design-system/msds-spritemap.svg';
import './Table.scss';

const tableSizeClassMap = {
    small: '',
    medium: 'msds-table--medium',
    large: 'msds-table--large',
};

const tableThemeClassMap = {
    default: '',
    dark: 'msds-table--dark',
    'dark-theme': 'msds-table--dark-theme',
};

// Wrapper for Grid.js which applies MSDS styling
function Table(props: TableProps) {
    const { size, theme, columns } = props;
    const tableSizeClass = tableSizeClassMap[size] ?? '';
    const tableThemeClass = tableThemeClassMap[theme] ?? '';
    const tableClasses = `msds-table ${tableSizeClass} ${tableThemeClass}`;

    // To apply classes to the elements inside the <th> element, we map the columns so that the
    // 'name' attribute returns an element with the proper classes applied
    const transformedColumns = columns?.map((column) => {
        if (typeof column === 'string') {
            return {
                id: column,
                name: _(
                    <div className="msds-table__header-headline">{column}</div>
                ),
            };
        } else
            return {
                ...column,
                name: _(
                    <div className="msds-table__header-headline">
                        {column.name}
                        {column.sort && (
                            <span className="msds-table__header-order-icon">
                                <svg className="msds-table__header-descending-order-icon">
                                    <use href={spritemap + '#right-arrow'} />
                                </svg>
                                <svg className="msds-table__header-acesnding-order-icon">
                                    <use href={spritemap + '#right-arrow'} />
                                </svg>
                            </span>
                        )}
                    </div>
                ),
            };
    });

    return (
        <Grid
            {...props}
            columns={transformedColumns}
            className={{
                table: tableClasses,
                thead: 'msds-table__head',
                tbody: 'msds-table__body',
                // Grid.js does not (easily) support applying different classes for <tr>
                // depending on thead / tbody, so for now, we always apply both
                tr: 'msds-table__body-row msds-table__head-row',
                th: 'msds-table__header',
                td: 'msds-table__body-row-data',
                //container: containerClasses,
            }}
        />
    );
}

export default Table;

type TableProps = {
    columns?: GridJSColumns;
    theme?: 'default' | 'dark' | 'dark-theme';
    size?: 'small' | 'medium' | 'large';
    [otherProps: string]: unknown;
};
